/**
 * Resolves the HTTP URL used for GraphQL mutations.
 * Uses `mutationEndpoint` when set (e.g. `NEXT_PUBLIC_GRAPHQL_MUTATION_ENDPOINT` from the host); otherwise falls back to `queryEndpoint`.
 */
export function resolveGraphqlMutationEndpoint(
  queryEndpoint?: string,
  mutationEndpoint?: string | null,
): string | undefined {
  const trimmed = mutationEndpoint?.trim();
  if (trimmed) {
    return trimmed;
  }
  return queryEndpoint;
}
